/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ContentTeaser.css'); }
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
var Button_1 = require("../Button");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-contentTeaser");
exports.ContentTeaser = function ContentTeaser(_a) {
    var children = _a.children, mobile = _a.mobile, title = _a.title, description = _a.description, className = _a.className, imageProps = _a.imageProps, buttonProps = _a.buttonProps, props = tslib_1.__rest(_a, ["children", "mobile", "title", "description", "className", "imageProps", "buttonProps"]);
    var image = !!imageProps ? (React.createElement("div", { className: classnames(moduleClassName("image")) },
        React.createElement("img", tslib_1.__assign({}, imageProps)))) : null;
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), mobile && !imageProps && moduleClassName("isCentered"), mobile && moduleClassName("isMobile"), className) }, props),
        React.createElement("div", { className: classnames(moduleClassName("content")) },
            mobile ? (React.createElement("div", { className: moduleClassName("mobileHeader") },
                React.createElement("h3", { className: moduleClassName("title") }, title),
                image)) : (React.createElement("h3", { className: moduleClassName("title") }, title)),
            React.createElement("p", { className: moduleClassName("description") }, description),
            !!buttonProps && (React.createElement(Button_1.Button, tslib_1.__assign({ block: !!mobile, size: "large", kind: "primary" }, buttonProps)))),
        !mobile && image));
};
exports.ContentTeaser.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    mobile: PropTypes.bool,
    description: PropTypes.node.isRequired,
    imageProps: PropTypes.object,
    buttonProps: PropTypes.object.isRequired
};